import { firstValueFrom } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BatchDTO, IBatchDTO } from "@DTOS";
import { Constants } from "@constants";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: "root"
})
export class BatchesServiceBackend {
    constructor(protected httpClient: HttpClient) {}

    public async getBatches(): Promise<BatchDTO[]> {
        return await firstValueFrom(
            this.httpClient.get<IBatchDTO[]>(`${Constants.apiURL}/batches`).pipe(
                map(response => response.map(batch => new BatchDTO(batch)))
            )
        ) ?? [];
    }

    public async postBatch(batch: BatchDTO): Promise<BatchDTO> {
        const response = await firstValueFrom(
            this.httpClient.post<IBatchDTO>(`${Constants.apiURL}/batches`, batch.toJSON())
        );
        return new BatchDTO(response);
    }

    public async deleteBatch(batch: BatchDTO) {
        await firstValueFrom(this.httpClient.delete(`${Constants.apiURL}/batches/${batch.id}`));
    }

    public async postAnswers(batch: BatchDTO, formData: FormData) {
        await firstValueFrom(this.httpClient.post(`${Constants.apiURL}/batches/${batch.id}/answers`, formData));
    }

    public async postDashboardAnswers(batch: BatchDTO, formData: FormData) {
        await firstValueFrom(this.httpClient.post(`${Constants.apiURL}/batches/${batch.id}/ansewerdashboard`, formData));
    }

    public async postUserDashboard(batch: BatchDTO, formData: FormData) {
        await firstValueFrom(this.httpClient.post(`${Constants.apiURL}/batches/${batch.id}/userdashboard`, formData));
    }
}
